module.exports = __webpack_public_path__ + "img/yoga.8315c05f.svg";